export const environment = {
  production: false,
  title: 'UK-EABS Development',
  backendUrl: 'https://api.uksigntest.com/api',
  news: {
    enabled: false,
    title: null,
    description: null,
    content: null,
  },
};
